<template>
    <v-dialog v-model="show"  fullscreen transition="dialog-bottom-transition" :overlay="false" persistent>
        <v-card dark>

            <v-card-text >
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12 >
                    <img
                      v-on:click="close()"
                      v-if="src != null"
                      class="image"
                      v-bind:src="src"
                      width="100%"
                      height="100%"
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ImageModal',
    props: {
        src: { required: true, default: null },
    },
    data() {
        return {

        }
    },
    computed:{
      show(){

        return this.src != null
      }
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
}
</script>

<style lang="css" scoped>
  .image{

  }
</style>



// WEBPACK FOOTER //
// src/components/helpers/modals/ImageModal.vue